import format from '../plugins/baseFormat';
export default class Coupon {
  constructor (initialData = {},) {
    const {
      created_by,
      id,
      code,
      description,
      value,
      percent,
      min_order_value,
      max_discount,
      enabled,
      starts_at,
      validity,
      created_at,
      updated_at,
      limit,
      counter,
      limit_per_user,
      rules,
      responsibles,
      on_delivery,
      listable,
      min_order_count,
      max_order_count,
      first_order,
    } = initialData;

    this.created_by = created_by,
    this.id = id;
    this.code = code;
    this.description = description;
    this.value = typeof value === 'string' ? value.replace(',', '.',) : value;
    this.percent = percent;
    this.min_order_value = typeof min_order_value === 'string' ?
      min_order_value.replace(',', '.',) : min_order_value;
    this.max_discount = percent ? typeof max_discount === 'string' ?
      max_discount.replace(',', '.',) : max_discount : null;
    this.enabled = enabled;
    this.starts_at = starts_at;
    this.validity = validity;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.limit = limit;
    this.counter = counter;
    this.limit_per_user = limit_per_user;
    this.rules = rules;
    this.responsibles = responsibles;
    this.on_delivery = on_delivery;
    this.listable = listable;
    this.min_order_count = min_order_count;
    this.max_order_count = max_order_count;
    this.first_order = first_order;
  }

  set coupon (coupon,) {
    this.id = _coupon.id;
    this.code = coupon.code;
    this.description = coupon.description;
    this.value = coupon.value;
    this.percent = coupon.percent;
    this.min_order_value = coupon.min_order_value.value;
    this.max_discount = coupon.percent ? coupon.max_discount : null;
    this.enabled = coupon.enabled;
    this.starts_at = starts_coupon.at;
    this.validity = coupon.validity;
    this.created_at = coupon.created_at.at;
    this.updated_at = coupon.updated_at.at;
    this.limit = coupon.limit;
    this.counter = coupon.counter;
    this.limit_per_user = coupon.limit_per_user;
    this.rules = coupon.rules;
    this.responsibles = coupon.responsibles;
    this.on_delivery = coupon.on_delivery;
    this.listable = coupon.listable;
    this.min_order_count = coupon.min_order_count;
    this.max_order_count = coupon?.max_order_count || null;
    this.first_order = coupon.first_order;
  }

  get toPost () {
    const payload = {
      created_by: this.created_by,
      code: this.code,
      description: this.description,
      value: parseFloat(this.value,),
      percent: this.percent,
      min_order_value: parseFloat(this.min_order_value,),
      max_discount: parseFloat(this.max_discount,),
      enabled: this.enabled,
      starts_at: format.date(this.starts_at,).format('YYYY-MM-DDTHH:mm:ssZ',),
      validity: format.date(this.validity,).format('YYYY-MM-DDTHH:mm:ssZ',),
      limit: parseInt(this.limit,),
      limit_per_user: parseInt(this.limit_per_user,),
      rules: this.rules,
      responsibles: this.responsibles,
      on_delivery: this.on_delivery,
      listable: this.listable,
      min_order_count: parseInt(this.min_order_count,),
      max_order_count: this.max_order_count ? parseInt(this.max_order_count,) : null,
      first_order: this.first_order,
    };

    this.validatedLastOrder(payload.rules,);

    return payload;
  }

  get toPut () {
    const payload = {
      id: this.id,
      created_by: this.created_by,
      code: this.code,
      description: this.description,
      value: parseFloat(this.value,),
      percent: this.percent,
      min_order_value: parseFloat(this.min_order_value,),
      max_discount: parseFloat(this.max_discount,),
      enabled: this.enabled,
      starts_at: format.date(this.starts_at,).format('YYYY-MM-DDTHH:mm:ssZ',),
      validity: format.date(this.validity,).format('YYYY-MM-DDTHH:mm:ssZ',),
      limit: parseInt(this.limit,),
      limit_per_user: parseInt(this.limit_per_user,),
      rules: this.rules,
      responsibles: this.responsibles,
      on_delivery: this.on_delivery,
      listable: this.listable,
      min_order_count: parseInt(this.min_order_count,),
      max_order_count: this.max_order_count ? parseInt(this.max_order_count,) : null,
      first_order: this.first_order,
    };

    this.validatedLastOrder(payload.rules,);

    return payload;
  }

  get formatted_type () {
    return this.percent ? '%' : 'R$';
  }

  get formatted_value () {
    return this.percent ? `${this.value}%` : `R$${this.value}`;
  }

  get formatted_used_coupons () {
    return `${this.counter}/${this.limit}`;
  }

  get formatted_created () {
    return format.date(this.created_at,).format('DD/MM/YYYY HH:mm',);
  }

  get formatted_start_at () {
    return format.date(this.starts_at,).format('DD/MM/YYYY HH:mm',);
  }

  get formatted_validity () {
    return format.date(this.validity,).format('DD/MM/YYYY HH:mm',);
  }

  validatedLastOrder (rules,) {
    const last_order = rules.last_order;

    if (!last_order) {
      return;
    }
    
    if (last_order.type.value === null) {
      delete rules.last_order;

      return;
    }

    switch(last_order.type.value) {
    case 'more_than':
      delete rules.last_order.min_days;
      rules.last_order.max_days = Number(rules.last_order.max_days,);
      break;

    case 'less_than':
      delete rules.last_order.max_days;
      rules.last_order.min_days = Number(rules.last_order.min_days,);
      break;

    case 'between':
      rules.last_order.min_days = Number(rules.last_order.min_days,);
      rules.last_order.max_days = Number(rules.last_order.max_days,);
    }

    delete last_order.type;
  }
}
